let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ksp3G")).then(() => parcelRequire('QbFsy'));